import { Injectable }   from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { InputBase } from './InputBase';

@Injectable()
export class InputControlService {
  constructor() { }

  toFormGroup(inputs: InputBase<any>[] ) {
    let group: any = {};

    inputs.forEach(question => {
      group[question.key] = question.required ? new FormControl({value:question.value || '', disabled:question.disabled}, Validators.required)
                                              : new FormControl({value:question.value || '', disabled:question.disabled});
    });
    return new FormGroup(group);
  }
}